import PropTypes from 'prop-types';
import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const Main = props => {
    return (
        <main
            className={props.className}
            id='main-content'
            tabIndex='-1'>
            {props.children}
        </main>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    className: PropTypes.string,
    children: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
        PropTypes.array
    ]).isRequired
};

Main.propTypes = propTypes;

export { Main };

export default Main;
